import { useState } from "react";
import { Button, Box } from "@mui/material";
import { CLOSE_NOTIFICATION_DIALOG_EVENT_NAME } from "../../features/account/constants";
import TextEditor from "../ui-atoms/text-editor/TextEditor";
import { useBroadcastNotificationMutation, useEditNotificationMutation } from "../../api/notifications";
import { NotificationType } from "./Notification";

type Props = {
  handleCancel: () => void;
  notification: NotificationType | null;
}

export default function BroadcastNotification({ handleCancel, notification }: Props) {
  const [message, setMessage] = useState(notification?.message ?? "");

  const broadcastNotification = useBroadcastNotificationMutation({
    onSuccess: () => handleCancel()
  });

  const editNotification = useEditNotificationMutation({
    onSuccess: () => handleCancel()
  });

  const save = () => {
    if (notification) {
      editNotification.mutate({ ...notification, message });
    } else {
      broadcastNotification.mutate(message);
    }
  }

  const handleTextChange = (text: string) => {
    setMessage(text);
  }

  const handleCancelBroadcast = () => {
    const event = new CustomEvent(CLOSE_NOTIFICATION_DIALOG_EVENT_NAME);
    window.dispatchEvent(event);

    setMessage('');
    handleCancel();
  }

  return (
    <Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
      <TextEditor
        handleChange={handleTextChange}
        onCloseEventName={CLOSE_NOTIFICATION_DIALOG_EVENT_NAME}
        message={message}
      />

      <Box display="flex" gap="16px" justifyContent="flex-end">
        <Button
          variant="contained"
          size="large"
          onClick={save}
        >
          Save
        </Button>
        <Button
          variant="outlined"
          size="large"
          onClick={handleCancelBroadcast}
        >
          Cancel
        </Button>
      </ Box>
    </Box>
  )
}